import styled from "styled-components";

import { BlogSliderContainer } from "../blog_slider/blog_slider.style";

export const ClientReviewContainer = styled(BlogSliderContainer)`
    .ClientReviewSlider{
        margin:3rem auto ;
    }
`